import Servers from '../../server'
import { fetchEventSource } from '@microsoft/fetch-event-source'

const DEFAULT_BASE = Servers.serverApi + '/api/residents/facial-recognition'

function authHeaders(token, extra = {}) {
  token = token || localStorage.getItem('access_token')
  return {
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...extra
  }
}

async function parseBody(res) {
  const ct = res.headers.get('content-type') || ''
  if (ct.includes('application/json')) return res.json()
  const text = await res.text()
  try { return JSON.parse(text) } catch { return { message: text } }
}

async function fetchJSON(url, opts = {}) {
  const res = await fetch(url, opts)
  const data = await parseBody(res)
  if (!res.ok) {
    const err = new Error(data?.error || data?.message || `HTTP ${res.status}`)
    err.status = res.status
    err.payload = data
    throw err
  }
  return data
}

/** POST /ingest-zip → 202 { jobId, message } */
export async function ingestZip({ token, file, identificationMode, baseUrl }) {
  const url = baseUrl || DEFAULT_BASE

  const form = new FormData()
  form.append('file', file)
  if (identificationMode) form.append('identificationMode', identificationMode)

  const data = await fetchJSON(`${url}/ingest-zip`, {
    method: 'POST',
    headers: authHeaders(token),
    body: form
  })
  return data
}

/** GET /ingest/result/{jobId} → IngestResult { items, failures } */
export async function getIngestResult({ jobId }) {
  const token = localStorage.getItem('access_token')
  const url = DEFAULT_BASE
  return fetchJSON(`${url}/ingest/result/${encodeURIComponent(jobId)}`, {
    headers: authHeaders(token)
  })
}

/** PATCH /ingest/item/{id} body { subjectType?, subjectUuid?, reviewStatus? } */
// export async function patchIngestItem({ id, body }) {
//   const token = localStorage.getItem('access_token')
//   const url = DEFAULT_BASE
//   return fetchJSON(`${url}/ingest/item/${encodeURIComponent(id)}`, {
//     method: 'PATCH',
//     headers: authHeaders(token, { 'Content-Type': 'application/json' }),
//     body: JSON.stringify(body || {})
//   })
// }

/** DELETE /ingest/{jobId}/item/{id} */
export async function deleteIngestItem({ jobId, id }) {
  const token = localStorage.getItem('access_token')
  const url = DEFAULT_BASE
  return fetchJSON(`${url}/ingest/${encodeURIComponent(jobId)}/item/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: authHeaders(token)
  })
}

// /** POST /ingest/{jobId}/approve-bulk body { status, ids } */
// export async function approveBulk({ token, jobId, status = 'APPROVED', ids }) {
//   const url = DEFAULT_BASE
//   const body = { status, ids }
//   return fetchJSON(`${url}/ingest/${encodeURIComponent(jobId)}/approve-bulk`, {
//     method: 'POST',
//     headers: authHeaders(token, { 'Content-Type': 'application/json' }),
//     body: JSON.stringify(body)
//   })
// }

// /** POST /ingest/{jobId}/confirm */
// export async function confirmIngest({ token, jobId }) {
//   const url = DEFAULT_BASE
//   return fetchJSON(`${url}/ingest/${encodeURIComponent(jobId)}/confirm`, {
//     method: 'POST',
//     headers: authHeaders(token)
//   })
// }

// En facialIngest.js - Solo actualiza estas dos funciones:

/** PATCH /ingest/item/{id} - CORREGIDO */
export async function patchIngestItem({ id, body }) {
  const token = localStorage.getItem('access_token')
  const url = DEFAULT_BASE

  return fetchJSON(`${url}/ingest/item/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body || {})
  })
}

/** POST /ingest/{jobId}/approve-bulk - CORREGIDO */
export async function approveBulk({ jobId, status = 'APPROVED' }) {
  const token = localStorage.getItem('access_token')
  const url = DEFAULT_BASE

  // Siempre enviar el body con status
  const body = { status }

  return fetchJSON(`${url}/ingest/${encodeURIComponent(jobId)}/approve-bulk`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
}

/** POST /ingest/{jobId}/confirm - YA ESTABA BIEN */
export async function confirmIngest({ jobId }) {
  const token = localStorage.getItem('access_token')
  const url = DEFAULT_BASE

  return fetchJSON(`${url}/ingest/${encodeURIComponent(jobId)}/confirm`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })
}

/**
 * SSE helper. Usa token en query string si authInQuery=true.
 * Retorna { close() }.
 */
export function openIngestSSE({
  token,
  jobId,
  // baseUrl,
  onOpen,
  onEvent,
  onError
}) {
  token = localStorage.getItem('access_token')

  const baseRoot = Servers.serverApi.replace(/\/$/, '')
  const base = `${baseRoot}/api/residents/facial-recognition`
  const url = `${base}/ingest/stream/${encodeURIComponent(jobId)}`

  const controller = new AbortController()

  fetchEventSource(url, {
    method: 'GET',
    signal: controller.signal,
    headers: token
      ? { Authorization: `Bearer ${token}` }
      : {},

    async onopen(res) {
      if (!res.ok) {
        const err = new Error(`SSE HTTP ${res.status}`)
        if (onError) onError(err)
        // Lanzar para que fetchEventSource deje de intentar reconectar
        throw err
      }
      onOpen && onOpen()
    },

    onmessage(msg) {
      if (!msg?.data) return

      try {
        const payload = JSON.parse(msg.data)

        // Si el backend usa `event: Foo`, úsalo como type cuando no venga en el JSON
        if (msg.event && msg.event !== 'message' && !payload.type) {
          payload.type = msg.event
        }

        onEvent && onEvent(payload)
      } catch {
        onEvent && onEvent({ type: 'LOG', message: msg.data })
      }
    },

    onerror(err) {
      // Esta función se llama cuando hay error en el stream
      onError && onError(err)
      // Si lanzas el error, fetchEventSource deja de reconectar.
      // Si quieres reintentos automáticos de la lib, NO lances error aquí.
      throw err
    }
  })

  // Devolvemos una API parecida a EventSource
  return {
    close() {
      controller.abort()
    }
  }
}

/** GET /residents/searchResident/guard?filterValue=... */
export async function searchResidentsGuard({ token, filterValue }) {
  token = localStorage.getItem('access_token')
  const root = Servers.serverApi.replace(/\/$/, '')
  const url = `${root}/api/residents/searchResident/guard?filterValue=${encodeURIComponent(filterValue || '')}`

  return fetchJSON(url, {
    headers: authHeaders(token)
  })
}

